import React from 'react'
import { Box } from '@mui/material';

import Navbar from '../../components/Navbar';

const TeacherDashboard = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Box sx={{ p: 2 }}>
        TeacherDashboard
      </Box>
    </Box>
  )
}

export default TeacherDashboard
// // src/pages/TeacherDashboard.js
// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   Box,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   IconButton,
//   Tooltip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Avatar,
//   Badge,
// } from '@mui/material';
// import {
//   QrCode2,
//   PlayArrow,
//   Stop,
//   Refresh,
//   Security,
//   Schedule,
//   Download,
//   Person,
//   CheckCircle,
//   FiberManualRecord,
// } from '@mui/icons-material';
// import { motion, AnimatePresence } from 'framer-motion';
// import { QRCodeSVG } from 'qrcode.react';
// import { useAuth } from '../contexts/AuthContext';
// import { enqueueSnackbar } from 'notistack';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// // import io from 'socket.io-client'; // Uncomment when backend is ready

// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';

// const TeacherDashboard = () => {
//   const { user } = useAuth();
//   const [activeSession, setActiveSession] = useState(null);
//   const [sessions, setSessions] = useState([]);
//   const [qrDialogOpen, setQrDialogOpen] = useState(false);
//   const [liveStudents, setLiveStudents] = useState([]);
//   const [newSession, setNewSession] = useState({
//     subject: '',
//     duration: 10,
//     location: '',
//   });
//   // const [socket, setSocket] = useState(null); // Uncomment for WebSocket

//   // WebSocket Connection for Live Updates
//   useEffect(() => {
//     if (activeSession) {
//       // PRODUCTION CODE - Uncomment when backend is ready:
//       /*
//       const newSocket = io('http://your-backend-url:3001', {
//         query: { sessionId: activeSession.id, teacherId: user.id }
//       });

//       newSocket.on('student-attendance', (studentData) => {
//         handleNewStudentAttendance(studentData);
//       });

//       setSocket(newSocket);

//       return () => {
//         newSocket.disconnect();
//       };
//       */

//       // DEMO CODE - Remove in production
//       const interval = setInterval(() => {
//         if (Math.random() > 0.6) {
//           simulateStudentAttendance();
//         }
//       }, 4000);

//       return () => clearInterval(interval);
//     }
//   }, [activeSession]);

//   // Demo function - Remove in production
//   const simulateStudentAttendance = () => {
//     const mockNames = ['Rahul Sharma', 'Priya Singh', 'Amit Kumar', 'Sneha Patel', 'Rohan Gupta'];
//     const mockStudent = {
//       id: Date.now(),
//       name: mockNames[Math.floor(Math.random() * mockNames.length)],
//       rollNo: `21BCE${Math.floor(1000 + Math.random() * 9000)}`,
//       email: `student${Math.floor(Math.random() * 100)}@example.com`,
//       timestamp: new Date().toLocaleTimeString(),
//       verified: true,
//     };
//     handleNewStudentAttendance(mockStudent);
//   };

//   const handleNewStudentAttendance = (studentData) => {
//     setLiveStudents(prev => {
//       // Avoid duplicates
//       if (prev.some(s => s.rollNo === studentData.rollNo)) {
//         enqueueSnackbar(`${studentData.name} already marked attendance`, { variant: 'warning' });
//         return prev;
//       }
      
//       enqueueSnackbar(`${studentData.name} marked attendance ✓`, { 
//         variant: 'success',
//         autoHideDuration: 2000,
//       });
      
//       return [studentData, ...prev]; // Add new student at the top
//     });

//     // Update active session
//     setActiveSession(prev => ({
//       ...prev,
//       students: [...(prev.students || []), studentData],
//     }));
//   };

//   const generateSessionCode = () => {
//     return Math.random().toString(36).substring(2, 8).toUpperCase();
//   };

//   const startSession = () => {
//     if (!newSession.subject || !newSession.location) {
//       enqueueSnackbar('Please fill all required fields', { variant: 'error' });
//       return;
//     }

//     const session = {
//       id: Date.now(),
//       code: generateSessionCode(),
//       subject: newSession.subject,
//       duration: newSession.duration,
//       location: newSession.location,
//       startTime: new Date(),
//       status: 'active',
//       students: [],
//     };
    
//     setActiveSession(session);
//     setSessions(prev => [session, ...prev]);
//     setLiveStudents([]);
//     setQrDialogOpen(true);
//     enqueueSnackbar('Attendance session started! 🎓', { variant: 'success' });

//     // Auto-refresh QR code every 2 minutes for security
//     const qrRefreshInterval = setInterval(() => {
//       if (activeSession) {
//         generateNewCode();
//       }
//     }, 120000); // 2 minutes

//     return () => clearInterval(qrRefreshInterval);
//   };

//   const stopSession = () => {
//     if (activeSession) {
//       if (liveStudents.length === 0) {
//         enqueueSnackbar('No students marked attendance', { variant: 'warning' });
//       } else {
//         generatePDF();
//       }
      
//       setActiveSession(null);
//       setQrDialogOpen(false);
//       enqueueSnackbar('Session ended successfully', { variant: 'info' });
//     }
//   };

//   const generatePDF = () => {
//     const doc = new jsPDF();
    
//     // Add header
//     doc.setFontSize(20);
//     doc.setTextColor(25, 118, 210);
//     doc.text('Attendance Report', 105, 20, { align: 'center' });
    
//     // Add session details
//     doc.setFontSize(11);
//     doc.setTextColor(0, 0, 0);
//     doc.text(`Subject: ${activeSession.subject}`, 20, 35);
//     doc.text(`Location: ${activeSession.location}`, 20, 42);
//     doc.text(`Date: ${new Date(activeSession.startTime).toLocaleDateString()}`, 20, 49);
//     doc.text(`Start Time: ${new Date(activeSession.startTime).toLocaleTimeString()}`, 20, 56);
//     doc.text(`Total Students Present: ${liveStudents.length}`, 20, 63);
//     doc.text(`Teacher: ${user?.name || 'N/A'}`, 20, 70);

//     // Add table
//     const tableData = liveStudents.map((student, index) => [
//       index + 1,
//       student.rollNo,
//       student.name,
//       student.email || 'N/A',
//       student.timestamp,
//       '✓ Present',
//     ]);

//     doc.autoTable({
//       startY: 80,
//       head: [['S.No', 'Roll No', 'Name', 'Email', 'Time', 'Status']],
//       body: tableData,
//       theme: 'grid',
//       headStyles: {
//         fillColor: [25, 118, 210],
//         textColor: 255,
//         fontStyle: 'bold',
//       },
//       styles: {
//         fontSize: 10,
//         cellPadding: 5,
//       },
//       alternateRowStyles: {
//         fillColor: [245, 245, 245],
//       },
//     });

//     // Add footer
//     const pageCount = doc.internal.getNumberOfPages();
//     doc.setFontSize(9);
//     doc.setTextColor(150);
//     doc.text(
//       `Generated on ${new Date().toLocaleString()}`,
//       105,
//       doc.internal.pageSize.height - 10,
//       { align: 'center' }
//     );

//     // Save PDF
//     const fileName = `Attendance_${activeSession.subject.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`;
//     doc.save(fileName);
    
//     enqueueSnackbar('PDF downloaded successfully! 📄', { variant: 'success' });
//   };

//   const generateNewCode = () => {
//     if (activeSession) {
//       setActiveSession(prev => ({
//         ...prev,
//         code: generateSessionCode(),
//       }));
//       enqueueSnackbar('New security code generated! 🔄', { variant: 'info' });
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <Container maxWidth="xl" sx={{ py: 4 }}>
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <Box sx={{ mb: 4 }}>
//             <Typography variant="h3" gutterBottom fontWeight="bold">
//               Teacher Dashboard
//             </Typography>
//             <Typography variant="h6" color="text.secondary">
//               Welcome back, {user?.name}
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {/* Session Control Card */}
//             <Grid item xs={12} md={6}>
//               <Card 
//                 component={motion.div}
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: "spring", stiffness: 300 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
//                     <Security sx={{ mr: 2, color: 'primary.main' }} />
//                     <Typography variant="h5" fontWeight="bold">
//                       Session Control
//                     </Typography>
//                   </Box>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <TextField
//                         fullWidth
//                         label="Subject"
//                         value={newSession.subject}
//                         onChange={(e) => setNewSession(prev => ({ ...prev, subject: e.target.value }))}
//                         margin="normal"
//                         required
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <TextField
//                         fullWidth
//                         label="Duration (minutes)"
//                         type="number"
//                         value={newSession.duration}
//                         onChange={(e) => setNewSession(prev => ({ ...prev, duration: e.target.value }))}
//                         margin="normal"
//                       />
//                     </Grid>
//                     <Grid item xs={6}>
//                       <TextField
//                         fullWidth
//                         label="Location"
//                         value={newSession.location}
//                         onChange={(e) => setNewSession(prev => ({ ...prev, location: e.target.value }))}
//                         margin="normal"
//                         required
//                       />
//                     </Grid>
//                   </Grid>

//                   <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
//                     <Button
//                       variant="contained"
//                       startIcon={<PlayArrow />}
//                       onClick={startSession}
//                       disabled={!newSession.subject || !newSession.location || activeSession}
//                       size="large"
//                     >
//                       Start Session
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       startIcon={<Stop />}
//                       onClick={stopSession}
//                       disabled={!activeSession}
//                       color="error"
//                     >
//                       Stop & Download PDF
//                     </Button>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Grid>

//             {/* Active Session Info */}
//             {activeSession && (
//               <Grid item xs={12} md={6}>
//                 <Card
//                   component={motion.div}
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   animate={{ opacity: 1, scale: 1 }}
//                 >
//                   <CardContent>
//                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
//                       <Typography variant="h6" fontWeight="bold">
//                         Active Session
//                       </Typography>
//                       <Badge
//                         badgeContent={
//                           <FiberManualRecord sx={{ fontSize: 12, color: '#ef5350' }} />
//                         }
//                         color="error"
//                       >
//                         <Chip 
//                           label="LIVE" 
//                           color="error" 
//                           icon={<Schedule />}
//                           size="small"
//                         />
//                       </Badge>
//                     </Box>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                       <Typography>
//                         <strong>Subject:</strong> {activeSession.subject}
//                       </Typography>
//                       <Typography>
//                         <strong>Location:</strong> {activeSession.location}
//                       </Typography>
//                       <Typography>
//                         <strong>Session Code:</strong> 
//                         <Chip 
//                           label={activeSession.code} 
//                           size="small" 
//                           color="primary"
//                           sx={{ ml: 1, fontWeight: 'bold' }}
//                         />
//                       </Typography>
//                       <Typography>
//                         <strong>Students Present:</strong> 
//                         <Chip 
//                           label={liveStudents.length} 
//                           size="small" 
//                           color="success"
//                           icon={<Person />}
//                           sx={{ ml: 1 }}
//                         />
//                       </Typography>
//                       <Box sx={{ display: 'flex', gap: 1 }}>
//                         <Button
//                           variant="outlined"
//                           startIcon={<QrCode2 />}
//                           onClick={() => setQrDialogOpen(true)}
//                           size="small"
//                         >
//                           Show QR Code
//                         </Button>
//                         <Button
//                           variant="outlined"
//                           startIcon={<Download />}
//                           onClick={generatePDF}
//                           disabled={liveStudents.length === 0}
//                           size="small"
//                           color="success"
//                         >
//                           Download PDF
//                         </Button>
//                       </Box>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             )}

//             {/* Live Attendance Feed */}
//             {activeSession && (
//               <Grid item xs={12}>
//                 <Card
//                   component={motion.div}
//                   initial={{ opacity: 0, y: 20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                 >
//                   <CardContent>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                         <Typography variant="h5" fontWeight="bold">
//                           Live Attendance Feed
//                         </Typography>
//                         <motion.div
//                           animate={{ scale: [1, 1.2, 1] }}
//                           transition={{ repeat: Infinity, duration: 2 }}
//                         >
//                           <FiberManualRecord sx={{ color: '#ef5350', fontSize: 16 }} />
//                         </motion.div>
//                       </Box>
//                       <Chip 
//                         label={`${liveStudents.length} Students`} 
//                         color="primary" 
//                         icon={<Person />}
//                       />
//                     </Box>

//                     <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 500 }}>
//                       <Table stickyHeader>
//                         <TableHead>
//                           <TableRow>
//                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>S.No</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Roll Number</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Name</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Time</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold', bgcolor: 'primary.main', color: 'white' }}>Status</TableCell>
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {liveStudents.length === 0 ? (
//                             <TableRow>
//                               <TableCell colSpan={5} align="center" sx={{ py: 8 }}>
//                                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//                                   <Person sx={{ fontSize: 60, color: 'text.disabled' }} />
//                                   <Typography color="text.secondary" variant="h6">
//                                     Waiting for students to mark attendance...
//                                   </Typography>
//                                   <Typography color="text.secondary" variant="body2">
//                                     Students will appear here in real-time as they scan the QR code
//                                   </Typography>
//                                 </Box>
//                               </TableCell>
//                             </TableRow>
//                           ) : (
//                             <AnimatePresence>
//                               {liveStudents.map((student, index) => (
//                                 <TableRow 
//                                   key={student.id}
//                                   component={motion.tr}
//                                   initial={{ opacity: 0, x: -20, backgroundColor: '#e3f2fd' }}
//                                   animate={{ opacity: 1, x: 0, backgroundColor: '#ffffff' }}
//                                   transition={{ duration: 0.5 }}
//                                   sx={{ '&:hover': { bgcolor: 'action.hover' } }}
//                                 >
//                                   <TableCell>{index + 1}</TableCell>
//                                   <TableCell>
//                                     <Chip 
//                                       label={student.rollNo} 
//                                       size="small" 
//                                       variant="outlined"
//                                     />
//                                   </TableCell>
//                                   <TableCell>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                       <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
//                                         {student.name.charAt(0)}
//                                       </Avatar>
//                                       <Typography fontWeight="500">
//                                         {student.name}
//                                       </Typography>
//                                     </Box>
//                                   </TableCell>
//                                   <TableCell>
//                                     <Chip 
//                                       label={student.timestamp} 
//                                       size="small"
//                                       icon={<Schedule sx={{ fontSize: 16 }} />}
//                                     />
//                                   </TableCell>
//                                   <TableCell>
//                                     <Chip 
//                                       icon={<CheckCircle />}
//                                       label="Present" 
//                                       color="success" 
//                                       size="small"
//                                     />
//                                   </TableCell>
//                                 </TableRow>
//                               ))}
//                             </AnimatePresence>
//                           )}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>

//                     {liveStudents.length > 0 && (
//                       <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
//                         <Button
//                           variant="contained"
//                           startIcon={<Download />}
//                           onClick={generatePDF}
//                           color="success"
//                         >
//                           Export to PDF
//                         </Button>
//                       </Box>
//                     )}
//                   </CardContent>
//                 </Card>
//               </Grid>
//             )}
//           </Grid>

//           {/* QR Code Dialog */}
//           <Dialog 
//             open={qrDialogOpen} 
//             onClose={() => setQrDialogOpen(false)}
//             maxWidth="sm"
//             fullWidth
//           >
//             <DialogTitle>
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <QrCode2 sx={{ mr: 2 }} />
//                 Attendance QR Code
//                 <Tooltip title="Generate New Code">
//                   <IconButton 
//                     onClick={generateNewCode}
//                     sx={{ ml: 'auto' }}
//                     color="primary"
//                   >
//                     <Refresh />
//                   </IconButton>
//                 </Tooltip>
//               </Box>
//             </DialogTitle>
//             <DialogContent>
//               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3 }}>
//                 {activeSession && (
//                   <>
//                     <QRCodeSVG 
//                       value={JSON.stringify({
//                         sessionId: activeSession.id,
//                         code: activeSession.code,
//                         location: activeSession.location,
//                         subject: activeSession.subject,
//                       })} 
//                       size={256}
//                       level="H"
//                     />
//                     <Typography variant="h6" sx={{ mt: 2 }}>
//                       Session Code: {activeSession.code}
//                     </Typography>
//                     <Alert severity="warning" sx={{ mt: 2, width: '100%' }}>
//                       This code refreshes every 2 minutes for security
//                     </Alert>
//                     <Box sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
//                       <Paper elevation={0} sx={{ p: 2, bgcolor: 'success.light', color: 'success.dark' }}>
//                         <Typography variant="h4" fontWeight="bold">
//                           {liveStudents.length}
//                         </Typography>
//                         <Typography variant="body2">
//                           Students Present
//                         </Typography>
//                       </Paper>
//                     </Box>
//                   </>
//                 )}
//               </Box>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={() => setQrDialogOpen(false)}>Close</Button>
//             </DialogActions>
//           </Dialog>
//         </motion.div>
//       </Container>
//       <Footer />
//     </>
//   );
// };

// export default TeacherDashboard;